export function getInitials(name) {
  if (!name) return '?';
  return name.split(' ').map(p => p[0]).join('').toUpperCase().slice(0, 2);
}

export function timeAgo(dateStr) {
  const diff = (Date.now() - new Date(dateStr).getTime()) / 1000;
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
  return new Date(dateStr).toLocaleDateString();
}

// Handicaps are stored the way golfers say them: 12.5 is a 12.5. Players
// better than scratch carry a "plus" handicap, stored negative (-2.1) and
// written with a leading plus (+2.1). Postgres DECIMALs arrive as strings.
export function formatHandicap(h) {
  if (h == null || h === '') return null;
  const n = Number(h);
  if (Number.isNaN(n)) return null;
  return n < 0 ? `+${Math.abs(n).toFixed(1)}` : n.toFixed(1);
}

const DAY_ABBR = {
  monday: 'Mon', tuesday: 'Tue', wednesday: 'Wed',
  thursday: 'Thu', friday: 'Fri', saturday: 'Sat', sunday: 'Sun'
};

export function formatAvailability(availability, separator = ' · ') {
  if (!availability || availability.length === 0) return 'Not specified';
  const grouped = availability.reduce((acc, { day_of_week, time_slot }) => {
    if (!acc[day_of_week]) acc[day_of_week] = [];
    acc[day_of_week].push(time_slot);
    return acc;
  }, {});
  return Object.entries(grouped)
    .map(([day, slots]) => `${DAY_ABBR[day]}: ${slots.join(', ')}`)
    .join(separator);
}

export function formatDate(dateStr) {
  if (!dateStr) return null;
  return new Date(dateStr).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export function formatTime(dateStr) {
  return new Date(dateStr).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
}

// Only follow ?redirect= values that stay inside the app ("/connect/abc"),
// never protocol-relative or absolute URLs ("//evil.com", "https://…").
export function safeRedirect(value, fallback = '/') {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\')) {
    return fallback;
  }
  return value;
}
